import React from 'react';
import styled from 'styled-components';
const StyledMenu = styled.ul `
  margin: 0;
  padding: 0;
  list-style: none;
`;
const Menu = ({ children, className }) => (React.createElement(StyledMenu, { className: className }, children));
export default Menu;
